<template>
  <transition name="fade">
    <div v-cloak class="toast" :class="position?'toast-'+position:'toast-center'" v-show="visible">
      <div class="toast-mask" v-if=" mask "></div>
      <div class="toast-content">{{ content }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  // props: ['position'],
  data() {
    return {
      visible: false,
      mask: true,
      closed: false,
      timer: null,
      duration: 1e3,
      content: '',
      position: '',
      customClass: ''
    }
  },
  watch: {
    closed(newVal, oldVal) {
      if (newVal) {
        this.visible = false
        this.$el.addEventListener('transitionend', this.destroyElement)
      }
    }
  },
  mounted() {
    // console.log('mounted')
    this.startTimer()
  },
  beforeDestroy() {
    // console.log('beforeDestroy')
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) this.close()
        }, this.duration)
      }
    },
    clearTimer() {
      clearTimeout(this.timer)
    },
    close() {
      this.closed = true
    },
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement)
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style>
.toast {
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 100%;
  top: 100%;
}
.toast-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0;
  z-index: 1000;
}
.toast-content {
  position: absolute;
  top: -50%;
  left: -50%;
  transform: translate(-50%, -50%);
  width: auto;
  max-width: 80%;
  /* padding: 0.27778rem 0.55556rem; */
  padding: 0px 13px 0px 13px;/*no*/
  line-height: 42px;/*no*/
  font-size: 12px;/*no*/
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  border-radius: 6px;/*no*/
  transform: translate(-50%, -50%);
}

.toast-bottom .toast-content {
  top: 0%;
  transform: translate(-50%, -200%);
}
</style>



// WEBPACK FOOTER //
// main.vue?356a30c9